<template>
	<div class="mt-4 ml-5 mr-5">
		<fullscreen
			background="#FFF"
			ref="fullscreen"
			@change="fullscreenChange"
		>
			<v-layout>
				<v-flex xs5 left>
					<h2>
						Indicador Status Mensal -
						<span v-if="selected > 0">Ano</span>
						{{ selected }}
					</h2>
				</v-flex>
				<v-flex xs3 left class="pl-10">
					<button title="Modo de Apresentação" type="button" @click="toggle">
						<v-icon
							large
							class="mdi"
							:class="[fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen']"
						></v-icon>
					</button>
				</v-flex>
				<v-spacer></v-spacer>
				<v-flex xs2>
					<v-select
						v-model="selects.filiais.value"
						:items="selects.filiais.items"
						label="Selecione a Filial"
						height="10"
						outlined
						autofocus
            dense
						item-value="filial"
						item-text="filial"
						@change="buscarIndicadorEstoqueMensal()"
					></v-select>
				</v-flex>
				<v-flex xs2 class="ml-5">
					<v-select
						v-model="selected"
						:items="anos"
            dense
						label="Selecione Ano"
						height="10"
						outlined
						autofocus
						item-value="ano"
						item-text="ano"
						@change="buscarIndicadorEstoqueMensal()"
					></v-select>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex xs12 class="mt-2">
					<ChatStatusMensal
            id="chart-stts-mensal-responsivo"
						:ano_corrente="selected"
						:filial="selects.filiais.value"
						style="padding: 0% 0% 0% 0%; margin-top: -35px"
					/>
				</v-flex>
				<!-- <v-flex xs2 class="ma-4">
					<p>
						<span
						class="dot-square"
						:style="{ backgroundColor: 'rgba(252, 186, 3,0.7)' }"
						></span>
						Estoque Total
					</p>
					<p>
						<span
						class="dot-square"
						:style="{ backgroundColor: 'rgba(1, 87, 155, 0.8)' }"
						></span>
						Estoque Itens Novos
					</p>
					<p>
						<span
						class="dot-square"
						:style="{ backgroundColor: 'rgba(45, 115, 53)' }"
						></span>
						Estoque Ideal
					</p>
					<p>
						<span
						class="dot-square"
						:style="{ backgroundColor: 'rgba(201, 194, 193,1)' }"
						></span>
						Estoque Residual
					</p>
					<p>
						<span
						class="dot-square"
						:style="{ backgroundColor: 'rgba(214, 14, 43,1)' }"
						></span>
						Estoque Necessidade
					</p>
				</v-flex> -->
			</v-layout>
			<!-- <v-layout style="padding:0;margin:0;">
                <v-spacer></v-spacer>
                <v-icon @click="exportarExcel()" class="exportar-excel" title="Exportar para o Excel">mdi-file-download</v-icon>
			</v-layout>-->
			<v-layout>
				<v-flex xs12>
					<v-simple-table
						v-if="desserts.length > 0"
						dense
						class="pa-1 elevation-2 remove-espacos-entre-colunas simple-table-indicadores"
					>
						<template v-slot:default>
							<thead>
								<tr>
									<th>&nbsp;Estoque</th>
									<th
										v-for="item in desserts"
										:key="item.nomemes"
										class="text-left"
										@click="organizarDadosParaDialogGeral(item)"
										style="cursor: pointer"
									>
										<div class="tudo-em-linha">{{ item.nomemes }}</div>
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="font-weight-bold">&nbsp;Total</td>
									<td v-for="item in desserts" :key="item.total_estoque_real">
										<div class="tudo-em-linha">
											<span style="padding-right: 5px">R$</span>
											<span>{{
												formatarValoresBi(item.total_estoque_real)
											}}</span>
										</div>
									</td>
								</tr>
								<tr>
									<td class="font-weight-bold">&nbsp;Itens Novos</td>
									<td v-for="item in desserts" :key="item.total_estoque_novo">
										<div class="tudo-em-linha">
											<span style="padding-right: 5px">R$</span>
											<span>{{
												formatarValoresBi(item.total_estoque_novo)
											}}</span>
										</div>
									</td>
								</tr>
								<tr>
									<td class="font-weight-bold">&nbsp;Excesso</td>
									<td
										v-for="item in desserts"
										:key="item.total_estoque_excesso"
									>
										<div class="tudo-em-linha">
											<span style="padding-right: 5px">R$</span>
											<span>{{
												formatarValoresBi(item.total_estoque_excesso)
											}}</span>
										</div>
									</td>
								</tr>
								<tr>
									<td class="font-weight-bold">&nbsp;Ideal</td>
									<td v-for="item in desserts" :key="item.total_estoque_ideal">
										<span class="tudo-em-linha"
											>R$
											{{ formatarValoresBi(item.total_estoque_ideal) }}</span
										>
									</td>
								</tr>
								<tr>
									<td class="font-weight-bold">&nbsp;Residual</td>
									<td
										v-for="item in desserts"
										:key="item.total_estoque_residual"
									>
										<div class="tudo-em-linha">
											<span style="padding-right: 5px">R$</span>
											<span>{{
												formatarValoresBi(item.total_estoque_residual)
											}}</span>
										</div>
									</td>
								</tr>
								<tr>
									<td class="font-weight-bold">&nbsp;Necessidade</td>
									<td
										v-for="item in desserts"
										:key="item.total_estoque_necessidade"
									>
										<div class="tudo-em-linha">
											<span style="padding-right: 5px">R$</span>
											<span>{{
												formatarValoresBi(item.total_estoque_necessidade)
											}}</span>
										</div>
									</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>
				</v-flex>
			</v-layout>
		</fullscreen>
		<!-- ABRE O DIALOG DE EXPORTAÇÃO DE RELATORIOS -->
		<v-layout justify-center>
			<dialog-relatorios
				:cardRelatorio="cardRelatoriosSelecionado"
				@defaultCard="cardRelatoriosSelecionado = $event"
			></dialog-relatorios>
		</v-layout>
	</div>
</template>
<script>
import ChatStatusMensal from "./Grafico.vue";
import IndicadoresAPI from "../../../api/indicadores";
import DrpAPI from "../../../api/drp";
import { mapGetters } from "vuex";
import dialogRelatorios from "../../layout/dialogRelatorios.vue";
import $axios from '../../../api/api.js'

// const now = new Date;

export default {
	name: "StatusMensal",
	components: {
		ChatStatusMensal,
		dialogRelatorios,
	},
	data() {
		return {
			fullscreen: false,
			anos: [],
			selected: "Periodo Dinâmico",
			extencaoRelatorio: "EXCEL",
			headers: [
				{
					text: "Ano",
					align: "left",
					value: "ano",
				},
				{ text: "Mês", value: "nomemes" },
				{ text: "Estoque Total", value: "total_estoque_real" },
				{ text: "Estoque Residual", value: "total_estoque_residual" },
				{ text: "Estoque Excesso", value: "total_estoque_excesso" },
				{ text: "Estoque Necessidade", value: "total_estoque_necessidade" },
				{ text: "Estoque Ideal", value: "total_estoque_ideal" },
			],
			desserts: [],

			selects: {
				filiais: {
					items: [],
					value: "Todas",
				},
				tiposRelatorio: {
					items: [{ tipo: "PDF" }, { tipo: "EXCEL" }],
				},
			},

			//para uso no dialog de uso geral
			CardStatusMensal: {
				titulo: "Relatório Indicador Status Mensal",
				ativo: false,
				headers: [
					{ text: "Id Produto", value: "idproduto" },
					{ text: "Descrição Produto", value: "descricao_produto" },
					{ text: "Estoque", value: "estoque" },
					{ text: "Estoque Segurança", value: "estoque_seguranca" },
					{ text: "Ponto Pedido", value: "ponto_pedido" },
					{ text: "Estoque Máximo", value: "estoque_maximo" },
					{ text: "Custo Unitario", value: "custo_unitario" },
					{ text: "Total", value: "total" },
				],
				itens: [],
				info: "",
				filtros: {
					filial: "",
					ano: "",
					mes: "",
				},
				url: "relatorio_indicador_estoque_mes",
				metodo: 8,
			},
			cardRelatoriosSelecionado: {},
		};
	},

	beforeMount() {
		this.buscaAnos();
	},

	mounted() {
		this.buscarIndicadorEstoqueMensal();
	},

	computed: {
		...mapGetters({
			grupoCompra: "usuario/getGrupoCompras",
		}),
	},

	created() {
		this.buscarFiliais();
	},

	watch: {
		grupoCompra() {
			this.buscarFiliais();
			this.buscarIndicadorEstoqueMensal();
		},
	},

	methods: {
		organizarDadosParaDialogGeral(item) {
			this.CardStatusMensal.filtros.filial = "";

			if (this.selects.filiais.value != "Todas") {
				this.CardStatusMensal.filtros.filial = this.selects.filiais.value;
			}

			this.CardStatusMensal.filtros.ano = item.ano;
			this.CardStatusMensal.filtros.mes = item.mes;

			this.cardRelatoriosSelecionado = this.CardStatusMensal;
		},

		buscarFiliais() {
			const headers = this.Helpers.iniciarRequisicao();

			const params = {
				grupo: this.grupoCompra,
			};

			this.selects.filiais.items = [];

			this.$store.dispatch(
				"loading/addRequisicao",
				DrpAPI.getFiliaisDrp(headers, params)
					.then((response) => {
						const token = response.data.token;
						localStorage.setItem("token", token);

						this.selects.filiais.items.push({ filial: "Todas" });

						const filiais = response.data.filiais;

						filiais.forEach((filial) => {
							this.selects.filiais.items.push(filial);
						});

						this.selects.filiais.value = this.selects.filiais.items[0].filial;
					})
					.catch(() => {
						this.Helpers.logout();
					})
			);
		},

		toggle() {
			this.$refs["fullscreen"].toggle();
		},
		fullscreenChange(fullscreen) {
			this.fullscreen = fullscreen;
		},
		buscaAnos() {
			const headers = this.Helpers.iniciarRequisicao();

			this.$store.dispatch(
				"loading/addRequisicao",
				IndicadoresAPI.getAnos(headers)
					.then((response) => {
						const token = response.data.token;
						localStorage.setItem("token", token);

						if (response.status == 200) {
							const selectAnos = response.data.anos;

							this.anos.push({ ano: "Periodo Dinâmico" });

							selectAnos.forEach((ano, i) => {
								this.anos.push({ ano: selectAnos[i].ano });
							});
						}
					})
					.catch(() => {
						this.Helpers.logout();
					})
			);
		},

		buscarIndicadorEstoqueMensal() {
			const headers = this.Helpers.iniciarRequisicao();

			const params = {
				ano: this.selected,
				grupo: this.grupoCompra,
				filial: this.selects.filiais.value,
			};

			this.$store.dispatch(
				"loading/addRequisicao",
				IndicadoresAPI.getIndicadorEstoqueMensal(headers, params)
					.then((response) => {
						const token = response.data.token;
						localStorage.setItem("token", token);

						if (response.status == 200) {
							this.desserts = response.data.indicador;
						}
					})
					.catch(() => {
						this.Helpers.logout();
					})
			);
		},

		exportarExcel() {
			let url = "indicadores_excel_grupo";
			url += "?ano=" + this.selected;
			url += "&grupo=" + this.grupoCompra;
			url += "&filial=" + this.selects.filiais.value;

			window.open($axios.defaults.baseURL + "/" + url, "_blank");
		},

		formatarValoresBi(n) {
			var ranges = [
				{ divider: 1e15, suffix: "P" },
				{ divider: 1e12, suffix: "T" },
				{ divider: 1e9, suffix: "G" },
				{ divider: 1e6, suffix: "M" },
				{ divider: 1e3, suffix: "k" },
			];

			for (var i = 0; i < ranges.length; i++) {
				if (Math.abs(n) >= ranges[i].divider) {
					return (
						(Math.round(n) / ranges[i].divider).toFixed(2).toString() +
						ranges[i].suffix
					);
				}
			}

			if (n == null) {
				n = "0.00";
			}

			return n;
		},
	},
};
</script>
<style scoped>
.dot-square {
	height: 15px;
	width: 20px;
	border-radius: 15%;
	display: inline-block;
}

table,
th,
td {
	font-size: 12px;
}

.exportar-excel {
	margin-top: -50px;
	margin-bottom: 10px;
	font-size: 2rem;
}

.text-left:hover {
	background: rgba(0, 0, 0, 0.08);
}

.tudo-em-linha {
	display: flex;
}
</style>

<style>
/* REMOVE ESPAÇOS ENTRE AS COLUNAS DA TABELA PARA QUE NAO QUEBRE EM MAIS DE UMA LINHA */

.remove-espacos-entre-colunas .v-data-table__wrapper table thead tr th {
	margin: 0;
	padding: 0;
}

.remove-espacos-entre-colunas .v-data-table__wrapper table tbody tr td {
	margin: 0;
	padding: 0;
}

#chart-stts-mensal-responsivo {
  height: calc(100vh - 360px) !important;
}
</style>
